import "./Category.scss";

import cat1 from "../../Category/category/cat-1.jpg"
// "../Category/category/cat-1.jpg"

const Category = () => {
    return (
        <div className="shop-by-category">
          
          <div className="categories">
            
            <div className="category">
                <img src={cat1} alt="headset" />
            </div>
            <div className="category">
                <img src={cat1} alt="headset" />
            </div>
            <div className="category">
                <img src={cat1} alt="headset" />
            </div>
            <div className="category">
                <img src={cat1} alt="headset" />
            </div>
            
          </div>
          
        </div>
    );
};

export default Category;
